var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextcloud(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "NextCloud",
    role: "img",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: "15%",
    fill: "#0082c9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffffff",
    strokeWidth: 33,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 40,
    cy: 256,
    cx: 120
  }), /*#__PURE__*/React.createElement("circle", {
    r: 71,
    cy: 256,
    cx: 256
  }), /*#__PURE__*/React.createElement("circle", {
    r: 40,
    cy: 256,
    cx: 392
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextcloud);
export default __webpack_public_path__ + "static/media/nextcloud.d66e61438693bf5c582caefc7de579f7.svg";
export { ForwardRef as ReactComponent };